function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import React from 'react';
import ReactConfetti from 'react-confetti';
import { motion } from 'framer-motion';
import Logo from '../icons/logos/Nightbot';
import { LandingPageAnchorIds } from '@/utils/constants';
import DashboardButton from '../DashboardButton';
import { Button, parseThemeColor, Text, Title, useMantineTheme } from '@mantine/core';
import styles from './HeroPanel.module.scss';
import useFragmentLink from '@/hooks/useFragmentLink';
function HeroPanel(props) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), confettiTime = _React_useState[0], setConfettiTime = _React_useState[1];
    var navigateToHash = useFragmentLink(LandingPageAnchorIds.FEATURES);
    var theme = useMantineTheme();
    var colors = React.useMemo(function() {
        var _parseThemeColor = parseThemeColor({
            color: 'red.4',
            theme: theme
        }), red = _parseThemeColor.value;
        var _parseThemeColor1 = parseThemeColor({
            color: 'orange.4',
            theme: theme
        }), orange = _parseThemeColor1.value;
        var _parseThemeColor2 = parseThemeColor({
            color: 'yellow.4',
            theme: theme
        }), yellow = _parseThemeColor2.value;
        var _parseThemeColor3 = parseThemeColor({
            color: 'green.4',
            theme: theme
        }), green = _parseThemeColor3.value;
        var _parseThemeColor4 = parseThemeColor({
            color: 'blue.4',
            theme: theme
        }), blue = _parseThemeColor4.value;
        return [
            red,
            orange,
            yellow,
            green,
            blue
        ];
    }, [
        theme
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: styles.heroPanelContainer
    }, props), {
        children: [
            confettiTime ? /*#__PURE__*/ _jsx(ReactConfetti, {
                style: {
                    width: '100%',
                    height: '100%'
                },
                colors: colors,
                run: confettiTime,
                recycle: false,
                onConfettiComplete: function() {
                    return setConfettiTime(false);
                }
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.heroPanelContent,
                children: [
                    /*#__PURE__*/ _jsx(motion.div, {
                        drag: true,
                        onClick: function() {
                            return setConfettiTime(true);
                        },
                        className: styles.logoContainer,
                        initial: {
                            scale: 0,
                            opacity: 0
                        },
                        animate: {
                            scale: 1,
                            opacity: 1
                        },
                        dragConstraints: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        },
                        whileDrag: {
                            scale: 0.9
                        },
                        whileHover: {
                            scale: 1.05
                        },
                        dragTransition: {
                            bounceStiffness: 300,
                            bounceDamping: 10
                        },
                        whileTap: {
                            scale: 0.8
                        },
                        children: /*#__PURE__*/ _jsx(Logo, {
                            className: styles.logo
                        })
                    }),
                    /*#__PURE__*/ _jsx(Title, {
                        className: styles.title,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "qjz1DC",
                            defaultMessage: "Your Live Chat Made Simple"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.description,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "wEfMG9",
                            defaultMessage: "An essential streamer tool for automating live chat messages, moderation, and more."
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.buttonContainer,
                        children: [
                            /*#__PURE__*/ _jsx(DashboardButton, {
                                rightSection: null,
                                variant: "inverse",
                                size: "lg",
                                radius: "xl"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                size: "lg",
                                onClick: navigateToHash,
                                variant: "filled",
                                radius: "xl",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "7DIW6+",
                                    defaultMessage: "Learn More"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
export default HeroPanel;
